import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./View_Profile.css";

import HeaderCard from "./HeaderCard/HeaderCard";
import ContactCard from "./ContactCard/ContactCard";
import ProfileScoreCard from "./ProfileScoreCard/ProfileScoreCard";
import NavigationTabs from "./NavigationTabs/NavigationTabs";

import SummaryCard from "./SummaryCard/SummaryCard";
import ResumeCard from "./ResumeCard/ResumeCard";
import WorkExperienceCard from "./WorkExperienceCard/WorkExperienceCard";
import SkillsCard from "./SkillsCard/SkillsCard";
import EducationCard from "./EducationCard/EducationCard";
import JobPreferencesCard from "./JobPreferencesCard/JobPreferencesCard";
import PersonalDetailsCard from "./PersonalDetailsCard/PersonalDetailsCard";
import CoursesCard from "./CoursesCard/CoursesCard";
import ProjectsCard from "./ProjectsCard/ProjectsCard";
import AwardsCard from "./AwardsCard/AwardsCard";
import SocialLinksCard from "./SocialLinksCard/SocialLinksCard";
import LanguagesCard from "./LanguagesCard/LanguagesCard";

function View_Profile() {
  return (
    <Container fluid className="profile-layout-wrapper py-5">
      <div className="container">
        <Row className="profile-layout-wrapper__row">
          {/* LEFT SIDEBAR */}
          <Col
            lg={3}
            md={4}
            sm={12}
            className="profile-layout-wrapper__sidebar"
          >
            <HeaderCard />
            <ContactCard />
            <ProfileScoreCard />
          </Col>

          {/* RIGHT CONTENT */}
          <Col lg={9} md={8} sm={12} className="profile-layout-wrapper__main">
            {/* TABS */}
            <NavigationTabs />

            {/* PROFILE SUMMARY */}
            <section id="summary">
              <SummaryCard />
            </section>

            {/* RESUME */}
            <section id="resume">
              <ResumeCard />
            </section>

            {/* WORK EXPERIENCE */}
            <section id="experience">
              <WorkExperienceCard />
            </section>

            {/* SKILLS */}
            <section id="skills">
              <SkillsCard />
            </section>

            {/* EDUCATION */}
            <section id="education">
              <EducationCard />
            </section>

            {/* JOB PREFERENCES */}
            <section id="job-preferences">
              <JobPreferencesCard />
            </section>

            {/* PERSONAL DETAILS */}
            <section id="personal-details">
              <PersonalDetailsCard />
            </section>

            {/* COURSES */}
            <section id="courses">
              <CoursesCard />
            </section>

            {/* PROJECTS */}
            <section id="projects">
              <ProjectsCard />
            </section>

            {/* AWARDS */}
            <section id="awards">
              <AwardsCard />
            </section>

            {/* SOCIAL LINKS */}
            <section id="social-links">
              <SocialLinksCard />
            </section>

            {/* LANGUAGES */}
            <section id="languages">
              <LanguagesCard />
            </section>
          </Col>
        </Row>
      </div>
    </Container>
  );
}

export default View_Profile;
